import React from "react";

interface PatientInfoProps {
  patient: {
    sex: string;
    age: string;
    note: string;
  };
  setPatient: (info: PatientInfoProps["patient"]) => void;
}

const PatientInfo: React.FC<PatientInfoProps> = ({ patient, setPatient }) => {
  return (
    <section className="surface-card">
      <div className="card-header">
        <h2 className="card-title">Patient Information</h2>
      </div>

      <div style={{ display: "flex", gap: "14px", alignItems: "center", flexWrap: "wrap" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <label
            htmlFor="patient-sex"
            style={{ margin: 0, fontSize: "0.82rem", color: "var(--text-soft)", fontWeight: 800 }}
          >
            Sex
          </label>
          <select
            id="patient-sex"
            className="app-select"
            value={patient.sex}
            onChange={(event) => setPatient({ ...patient, sex: event.target.value })}
            style={{ width: "112px", minWidth: "112px" }}
          >
            <option value="">Select</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
          </select>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <label
            htmlFor="patient-age"
            style={{ margin: 0, fontSize: "0.82rem", color: "var(--text-soft)", fontWeight: 800 }}
          >
            Age
          </label>
          <input
            id="patient-age"
            className="app-input"
            inputMode="numeric"
            value={patient.age}
            onChange={(event) => setPatient({ ...patient, age: event.target.value })}
            placeholder="Age"
            style={{ width: "84px", minWidth: "84px" }}
          />
        </div>
      </div>

      <div className="field-group" style={{ marginTop: "12px" }}>
        <label htmlFor="patient-note">Additional Notes</label>
        <textarea
          id="patient-note"
          className="app-textarea"
          placeholder="- Additional patient information in free form (history, physical exam, other diagnostic test findings, etc.)"
          value={patient.note}
          onChange={(event) => setPatient({ ...patient, note: event.target.value })}
        />
      </div>
    </section>
  );
};

export default PatientInfo;
